








import Contests from "@/components/meter/Contests.vue";
import Projects from "@/components/meter/Projects.vue";
import ToWin from "@/components/meter/ToWin.vue";

export default {
  name: "Meters",
  components: {Projects, Contests, ToWin}
}
